import { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { AppRoutes } from "@/app/routes";
import { ScrollRestoration } from "@/app/ScrollRestoration";
import { Providers } from "@/shared/providers/Providers";
import { AppErrorBoundary } from "@/features/app/components/AppErrorBoundary";
import { PageViewTracker } from "@/lib/analytics/PageViewTracker";
import { siteConfig } from "@/lib/seo/metadata";
import { AppLoadingScreen } from "@/shared/layout/AppLoadingScreen";
import { NotificationHeaderProvider } from "@/features/notifications/components/NotificationHeaderProvider";

function App() {
  return (
    <Providers>
      <AppErrorBoundary>
        {/* Fallback tab title for routes that don't set their own; page titles override it. */}
        <Helmet defaultTitle={siteConfig.title} />
        <PageViewTracker />
        <ScrollRestoration />
        <div className="antialiased font-sans">
          <Suspense fallback={<AppLoadingScreen />}>
            <NotificationHeaderProvider>
              <AppRoutes />
            </NotificationHeaderProvider>
          </Suspense>
        </div>
      </AppErrorBoundary>
    </Providers>
  );
}

export default App;
